export const translations = {
  it: {
    nav: {
      features: "Funzionalità",
      manifesto: "Manifesto",
      pricing: "Prezzi",
      faq: "FAQ",
      openApp: "Accedi all'app",
      reserved: "Area Riservata",
    },
    reserved: {
      kicker: "Area Riservata",
      heading: "Accedi al tuo account.",
      sub: "Usa le stesse credenziali dell'app metal-class della tua azienda.",
      username: "Username",
      password: "Password",
      submit: "Accedi",
      loggingIn: "Accesso in corso…",
      errorGeneric: "Accesso non riuscito. Controlla le credenziali e riprova.",
      welcome: "Bentornato",
      logout: "Esci",
      classifications: "Classificazioni",
      suppliers: "Fornitori",
      recent: "Ultime classificazioni",
      empty: "Ancora nessuna classificazione registrata.",
      dataError: "Dati temporaneamente non disponibili. Riprova tra poco.",
      tabs: { storico: "Storico", fornitori: "Fornitori", aziende: "Aziende", admin: "Admin" },
      searchPh: "Cerca per fornitore o descrizione…",
      delete: "Elimina",
      confirmDelete: "Eliminare definitivamente?",
      supplierNamePh: "Nome fornitore",
      searchSupplierPh: "Cerca fornitore…",
      addSupplier: "Aggiungi",
      emptySuppliers: "Ancora nessun fornitore.",
      sent: "Inviata",
      draft: "Salvata",
      by: "di",
      pending: "Utenti in attesa di approvazione",
      noPending: "Nessuna richiesta in attesa.",
      approve: "Approva",
      block: "Blocca",
      allUsers: "Utenti dell'azienda",
      companySettings: "Impostazioni azienda",
      companyCode: "Codice azienda",
      emailClassifiche: "Email per le classifiche",
      save: "Salva",
      saved: "Salvato.",
      viewList: "Lista",
      viewCalendar: "Calendario",
      allDates: "Mostra tutte le date",
      noPhotos: "Nessuna foto allegata",
      discountLabel: "Sconto",
      statusLabel: "Stato",
      descriptionLabel: "Descrizione",
      confirmToggle: "Confermi il cambio di stato dell'azienda?",
      totalCompanies: "Aziende",
      activeCompanies: "Attive",
      totalUsers: "Utenti",
      totalClassifications: "Classificazioni",
      activeLabel: "Attiva",
      inactiveLabel: "Disattivata",
      deactivate: "Disattiva",
      activate: "Riattiva",
      usersLabel: "utenti",
      classificationsLabel: "classificazioni",
      since: "dal",
      dayEmpty: "Nessuna classificazione in questo giorno.",
      exportCsv: "Esporta CSV",
      exportTitle: "Esporta storico",
      fromDate: "Da",
      toDate: "A",
      pickDate: "gg/mm/aaaa",
      noDate: "Nessuna data",
      clearDates: "Azzera date",
      filterSupplier: "Fornitore / Materiale",
      filterStatus: "Stato",
      filterOperator: "Operatore",
      exportAll: "Tutti",
      downloadCsv: "Scarica CSV",
      formatLabel: "Formato",
      formats: { csv: "CSV (dati)", xlsx: "Excel con foto", pdf: "PDF stampabile" },
      loadingPhotos: "Preparazione foto…",
      downloadFile: "Scarica",
      exportedOn: "Generato il",
      showMore: "Mostra altre",
      weekdays: ["L", "M", "M", "G", "V", "S", "D"],
    },
    hero: {
      eyebrow: "metal-class — Gestione magazzino metalli",
      lines: ["IL CONTROLLO", "TOTALE", "SUL METALLO."],
      serif: "Ogni lotto, ogni sconto, ogni movimento. Documentato.",
      sub: "Classifica il materiale in ingresso e in uscita, gestisci fornitori e clienti con sconti percentuali, allega fotografie e sincronizza tutto sulla mail del server aziendale. Automaticamente.",
      ctaPrimary: "Inizia la prova gratuita",
      ctaSecondary: "Scopri le funzionalità",
      stats: [
        { value: "0€", label: "per 15 giorni di prova" },
        { value: "Zero", label: "vincoli o carte di credito" },
        { value: "100%", label: "controllo amministratore" },
      ],
      frame: {
        title: "Registro movimenti",
        sync: "Sincronizzato → server aziendale",
        in: "INGRESSO",
        out: "USCITA",
        rows: [
          { type: "in", material: "Rame 1° qualità", weight: "240 kg", party: "Rossi Metalli", discount: "-3%" },
          { type: "out", material: "Ottone", weight: "85 kg", party: "Fonderia Brivio", discount: "-5%" },
          { type: "in", material: "Acciaio INOX", weight: "410 kg", party: "Ferramenta Lanka", discount: "-2%" },
        ],
      },
      scroll: "Scorri",
    },
    marquee: [
      "Gestione magazzino",
      "Controllo totale",
      "Precisione industriale",
      "Oltre il deposito",
      "Tracciabilità completa",
    ],
    manifesto: {
      kicker: "Il Manifesto",
      chapters: [
        {
          n: "01",
          title: "Il caos del magazzino",
          text: "Registrazioni su carta, fogli Excel dispersi, foto perse nelle chat. Nel commercio dei metalli ogni dato perso è margine perso.",
        },
        {
          n: "02",
          title: "Un'unica fonte di verità",
          text: "metal-class classifica ogni ingresso e uscita: fornitori, clienti, sconti percentuali e fotografie allegate a ogni lotto.",
        },
        {
          n: "03",
          title: "Controllo dall'alto",
          text: "L'amministratore supervisiona ogni operazione del personale. Report automatici sulla mail del server aziendale. Storico ricercabile per materiale e periodo.",
        },
      ],
    },
    features: {
      kicker: "Funzionalità",
      heading: "Costruita per chi commercia metallo.",
      sub: "Sette strumenti, un solo obiettivo: il pieno controllo del lavoro svolto.",
      items: [
        { title: "Classificazione In/Out", desc: "Registra ogni materiale in ingresso e in uscita dal magazzino, con data, peso e tipologia." },
        { title: "Fornitori & Clienti", desc: "Anagrafiche complete, sempre a portata di mano." },
        { title: "Sconti Percentuali", desc: "Applica sconti in percentuale sui materiali per ogni contatto." },
        { title: "Foto Allegate", desc: "Allega fotografie del materiale direttamente in app: prova visiva di ogni movimento." },
        { title: "Invio Automatico", desc: "Ogni registrazione arriva via email sul server aziendale, senza passaggi manuali." },
        { title: "Controllo Personale", desc: "L'amministratore ha visibilità totale sul lavoro di ogni operatore." },
        { title: "Storico Avanzato", desc: "Ricerche filtrate per materiale, periodo temporale e operatore." },
      ],
    },
    showcase: {
      kicker: "L'app dal vivo",
      heading: "Precisione che si vede.",
      captions: [
        { title: "Classifica in pochi tap.", sub: "Foto del lotto, data, fornitore e sconto percentuale. Tutto in un unico gesto." },
        { title: "Lo storico, a calendario.", sub: "Filtri per data e materiale, vista lista o selezione multipla." },
        { title: "L'admin vede tutto.", sub: "Gestione utenti, approvazioni ed email del server aziendale." },
        { title: "Accesso su invito.", sub: "Ogni account è verificato con il codice azienda e approvato dall'amministratore." },
      ],
    },
    pricing: {
      kicker: "Prezzi",
      heading: "Provala gratis. Poi decidi.",
      badge: "15 giorni di prova gratuita",
      price: "0€",
      per: "/15 giorni",
      terms: "Al termine della prova ti presentiamo l'offerta. Nessun vincolo, disdici quando vuoi.",
      list: [
        "Accesso completo a tutte le funzionalità",
        "Fornitori, clienti e sconti percentuali",
        "Foto allegate e invio automatico al server",
        "Storico ricercabile senza limiti",
      ],
      cta: "Richiedi la prova gratuita",
      note: "Nessuna carta di credito richiesta.",
    },
    faq: {
      kicker: "FAQ",
      heading: "Domande frequenti.",
      items: [
        { q: "Come funziona la prova gratuita?", a: "Hai 15 giorni per provare l'app con tutte le funzionalità attive. Senza carta di credito e senza impegno: scrivici una mail e ti attiviamo l'accesso." },
        { q: "Cosa succede dopo i 15 giorni?", a: "Se l'app ti convince, ti proponiamo il piano di abbonamento più adatto alla tua azienda. Nessun contratto vincolante: puoi rescindere in qualsiasi momento, senza penali." },
        { q: "Chi può usare l'app in azienda?", a: "L'amministratore ha il controllo totale e può far lavorare il personale con supervisione completa su ogni operazione registrata." },
        { q: "Dove finiscono i miei dati?", a: "Ogni registrazione — materiali, foto, sconti — viene inviata automaticamente alla mail del server aziendale, così hai sempre un archivio completo del lavoro svolto." },
        { q: "Posso ritrovare vecchi movimenti?", a: "Sì. Lo storico è ricercabile con filtri personalizzati: per materiale, spazio temporale e altro ancora." },
        { q: "Devo installare qualcosa?", a: "No. metal-class è un'app web: la usi dal browser, in officina come in ufficio, da qualunque dispositivo." },
      ],
    },
    cta: {
      heading: "Il tuo magazzino, sotto controllo.",
      sub: "Scrivici ora e attiva 15 giorni di prova gratuita. Poi decidi se continuare, senza vincoli.",
      button: "Attiva la prova gratuita",
      openApp: "Accedi all'app",
    },
    contact: {
      kicker: "Richiedi la prova",
      heading: "Attiva i tuoi 15 giorni gratuiti.",
      sub: "Compila il modulo e ti ricontattiamo per attivare l'accesso. Zero vincoli, zero carte.",
      company: "Azienda",
      companyPh: "Es. Newco Srl",
      name: "Nome e cognome",
      namePh: "Il tuo nome",
      phone: "Telefono",
      phonePh: "Es. 333 1234567",
      email: "Email",
      emailPh: "nome@azienda.it",
      submit: "Invia la richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti ricontattiamo a breve.",
      error: "Invio non riuscito. Riprova o scrivici via email.",
      privacy: "I tuoi dati servono solo ad attivare la prova. Niente spam.",
      direct: "Oppure scrivici direttamente:",
    },
    footer: {
      contact: "Contatti",
      rights: "© 2026 metal-class — Tutti i diritti riservati.",
    },
  },
  en: {
    nav: {
      features: "Features",
      manifesto: "Manifesto",
      pricing: "Pricing",
      faq: "FAQ",
      openApp: "Open the App",
      reserved: "Members Area",
    },
    reserved: {
      kicker: "Members Area",
      heading: "Sign in to your account.",
      sub: "Use the same metal-class credentials as your company app.",
      username: "Username",
      password: "Password",
      submit: "Sign in",
      loggingIn: "Signing in…",
      errorGeneric: "Sign-in failed. Check your credentials and try again.",
      welcome: "Welcome back",
      logout: "Log out",
      classifications: "Classifications",
      suppliers: "Suppliers",
      recent: "Latest classifications",
      empty: "No classifications recorded yet.",
      dataError: "Data temporarily unavailable. Please try again shortly.",
      tabs: { storico: "History", fornitori: "Suppliers", aziende: "Companies", admin: "Admin" },
      searchPh: "Search by supplier or description…",
      delete: "Delete",
      confirmDelete: "Delete permanently?",
      supplierNamePh: "Supplier name",
      searchSupplierPh: "Search supplier…",
      addSupplier: "Add",
      emptySuppliers: "No suppliers yet.",
      sent: "Sent",
      draft: "Saved",
      by: "by",
      pending: "Users awaiting approval",
      noPending: "No pending requests.",
      approve: "Approve",
      block: "Block",
      allUsers: "Company users",
      companySettings: "Company settings",
      companyCode: "Company code",
      emailClassifiche: "Classifications email",
      save: "Save",
      saved: "Saved.",
      viewList: "List",
      viewCalendar: "Calendar",
      allDates: "Show all dates",
      noPhotos: "No photos attached",
      discountLabel: "Discount",
      statusLabel: "Status",
      descriptionLabel: "Description",
      confirmToggle: "Confirm the company status change?",
      totalCompanies: "Companies",
      activeCompanies: "Active",
      totalUsers: "Users",
      totalClassifications: "Classifications",
      activeLabel: "Active",
      inactiveLabel: "Disabled",
      deactivate: "Disable",
      activate: "Reactivate",
      usersLabel: "users",
      classificationsLabel: "classifications",
      since: "since",
      dayEmpty: "No classifications on this day.",
      exportCsv: "Export CSV",
      exportTitle: "Export history",
      fromDate: "From",
      toDate: "To",
      pickDate: "dd/mm/yyyy",
      noDate: "No date",
      clearDates: "Clear dates",
      filterSupplier: "Supplier / Material",
      filterStatus: "Status",
      filterOperator: "Operator",
      exportAll: "All",
      downloadCsv: "Download CSV",
      formatLabel: "Format",
      formats: { csv: "CSV (data)", xlsx: "Excel with photos", pdf: "Printable PDF" },
      loadingPhotos: "Preparing photos…",
      downloadFile: "Download",
      exportedOn: "Generated on",
      showMore: "Show more",
      weekdays: ["M", "T", "W", "T", "F", "S", "S"],
    },
    hero: {
      eyebrow: "metal-class — Metal warehouse management",
      lines: ["TOTAL CONTROL", "OVER YOUR", "METAL."],
      serif: "Every lot, every discount, every movement. Documented.",
      sub: "Classify inbound and outbound material, manage suppliers and customers with percentage discounts, attach photos and sync everything to your company server inbox. Automatically.",
      ctaPrimary: "Start your free trial",
      ctaSecondary: "Explore features",
      stats: [
        { value: "€0", label: "for a 15-day trial" },
        { value: "Zero", label: "lock-in, no credit card" },
        { value: "100%", label: "admin control" },
      ],
      frame: {
        title: "Movements log",
        sync: "Synced → company server",
        in: "INBOUND",
        out: "OUTBOUND",
        rows: [
          { type: "in", material: "Grade 1 Copper", weight: "240 kg", party: "Rossi Metalli", discount: "-3%" },
          { type: "out", material: "Brass", weight: "85 kg", party: "Fonderia Brivio", discount: "-5%" },
          { type: "in", material: "Stainless Steel", weight: "410 kg", party: "Ferramenta Lanka", discount: "-2%" },
        ],
      },
      scroll: "Scroll",
    },
    marquee: [
      "Warehouse management",
      "Total control",
      "Industrial precision",
      "Beyond storage",
      "Full traceability",
    ],
    manifesto: {
      kicker: "The Manifesto",
      chapters: [
        {
          n: "01",
          title: "Warehouse chaos",
          text: "Paper logs, scattered spreadsheets, photos lost in chats. In metal trading, every lost record is lost margin.",
        },
        {
          n: "02",
          title: "A single source of truth",
          text: "metal-class classifies every inbound and outbound movement: suppliers, customers, percentage discounts and photos attached to each lot.",
        },
        {
          n: "03",
          title: "Top-down control",
          text: "The administrator oversees every staff operation. Automatic reports to the company server inbox. History searchable by material and time period.",
        },
      ],
    },
    features: {
      kicker: "Features",
      heading: "Built for those who trade metal.",
      sub: "Seven tools, one goal: full control over the work done.",
      items: [
        { title: "In/Out Classification", desc: "Log every inbound and outbound material with date, weight and type." },
        { title: "Suppliers & Customers", desc: "Complete records, always at hand." },
        { title: "Percentage Discounts", desc: "Apply percentage discounts on materials for each contact." },
        { title: "Photo Attachments", desc: "Attach photos of the material directly in the app: visual proof of every movement." },
        { title: "Automatic Sending", desc: "Every record lands on the company server inbox via email, with no manual steps." },
        { title: "Staff Oversight", desc: "The administrator has full visibility over every operator's work." },
        { title: "Advanced History", desc: "Filtered searches by material, time period and operator." },
      ],
    },
    showcase: {
      kicker: "The app, live",
      heading: "Precision you can see.",
      captions: [
        { title: "Classify in a few taps.", sub: "Lot photos, date, supplier and percentage discount. All in one gesture." },
        { title: "History, on a calendar.", sub: "Filters by date and material, list view or multi-select." },
        { title: "Admin sees everything.", sub: "User management, approvals and company server email." },
        { title: "Invite-only access.", sub: "Every account is verified with a company code and approved by the administrator." },
      ],
    },
    pricing: {
      kicker: "Pricing",
      heading: "Try it free. Then decide.",
      badge: "15-day free trial",
      price: "€0",
      per: "/15 days",
      terms: "At the end of the trial we'll present you the offer. No lock-in, cancel anytime.",
      list: [
        "Full access to every feature",
        "Suppliers, customers & percentage discounts",
        "Photo attachments & automatic server sending",
        "Unlimited searchable history",
      ],
      cta: "Request your free trial",
      note: "No credit card required.",
    },
    faq: {
      kicker: "FAQ",
      heading: "Frequently asked questions.",
      items: [
        { q: "How does the free trial work?", a: "You get 15 days with every feature unlocked. No credit card, no commitment: send us an email and we activate your access." },
        { q: "What happens after the 15 days?", a: "If the app convinces you, we'll propose the subscription plan that best fits your company. No binding contract: cancel anytime, no penalties." },
        { q: "Who can use the app in my company?", a: "The administrator has total control and can let staff work with complete oversight on every recorded operation." },
        { q: "Where does my data go?", a: "Every record — materials, photos, discounts — is automatically emailed to your company server, so you always have a complete archive of the work done." },
        { q: "Can I retrieve old movements?", a: "Yes. History is searchable with custom filters: by material, time period and more." },
        { q: "Do I need to install anything?", a: "No. metal-class is a web app: use it from the browser, in the workshop or the office, from any device." },
      ],
    },
    cta: {
      heading: "Your warehouse, under control.",
      sub: "Write to us now and activate 15 days of free trial. Then decide whether to continue, with no lock-in.",
      button: "Activate your free trial",
      openApp: "Open the App",
    },
    contact: {
      kicker: "Request the trial",
      heading: "Activate your 15 free days.",
      sub: "Fill in the form and we'll get back to you to activate your access. No lock-in, no cards.",
      company: "Company",
      companyPh: "E.g. Newco Ltd",
      name: "Full name",
      namePh: "Your name",
      phone: "Phone",
      phonePh: "E.g. +39 333 1234567",
      email: "Email",
      emailPh: "name@company.com",
      submit: "Send the request",
      sending: "Sending…",
      success: "Request sent. We'll get back to you shortly.",
      error: "Sending failed. Try again or email us directly.",
      privacy: "Your data is only used to activate the trial. No spam.",
      direct: "Or write to us directly:",
    },
    footer: {
      contact: "Contact",
      rights: "© 2026 metal-class — All rights reserved.",
    },
  },
};
